import { Component } from '@angular/core';

@Component({
  selector: 'app-syllabus-edit-button',
  template: '<ng-content></ng-content>'
})
export class SyllabusEditButtonComponent {

  constructor() { }

}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/syllabuses/syllabus-edit-button/syllabus-edit-button.component.ts